import {QuickGuideStep} from "../model/QuickGuideStep";
import {FAQ} from "../model/FAQ";

export const RawProvider = {

    faq: require("./raw/faq.json") as [FAQ],

    quickGuide: {
        closeReservation: require("./raw/quickGuide/close_reservation.json") as [QuickGuideStep],
        confirmReservation: require("./raw/quickGuide/confirm_reservation.json") as [QuickGuideStep],
        createReservation: require("./raw/quickGuide/create_reservation.json") as [QuickGuideStep],
        login: require("./raw/quickGuide/login.json") as [QuickGuideStep],
        showMapCreateReservation: require("./raw/quickGuide/show_map_create_reservation.json") as [QuickGuideStep],
        showMapReservationDetail: require("./raw/quickGuide/show_map_reservation_detail.json") as [QuickGuideStep],
    }


}
